<!-- Link to PDF -->
<div class="centerLinkInDiv">
	<a class="pdrButton" href="/assets/privacy_policy.pdf">Get PDF</a>
</div>

<div class="pdfContainer">
    <embed class="pdfViewer" src="/assets/privacy_policy.pdf">
</div>
